<template>
  <form-sections
    :schema="schema"
    buttonless
    class="invitations-form"
    @change="change"
    @paste="paste"
  />
</template>

<script>
  import mobile from '@sdk/helpers/interface/mobile';
  import form from '@cordel/helpers/form/mixin';

  import FormSections from '@cordel/components/Form/Sections.vue';

  // eslint-disable-next-line import/no-extraneous-dependencies
  import preload from '@/helpers/mixins/preload';

  import payloadGenerator from './Form/payload';
  import schemaGenerator from './Form/schema';

  export default {
    name: 'InvitationsForm',
    components: {
      FormSections,
    },
    mixins: [
      preload,
      mobile,
      form,
    ],
    props: {
      email: {
        type: String,
        default: '',
      },
      permission: {
        type: Number,
        default: null,
      },
      index: {
        type: Number,
        default: null,
      },
    },
    data() {
      return {
        schema: schemaGenerator(),
        payload: payloadGenerator(),
      };
    },
    methods: {
      change(field, value) {
        this.$emit('change', field, this.index, value);
      },
      paste(field, e) {
        this.$emit('paste', field, this.index, e);
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@cordel/assets/stylesheets/mixins/reset.scss';
  @import '@cordel/assets/stylesheets/variables/breakpoints.scss';

  .invitations-form {
    margin-top: calc(-1 * var(--cordel-spacing-xxblaster));
    padding: var(--cordel-spacing-xl) 0
             var(--cordel-spacing-blaster) 0;
    width: 100%;

    @media all and (max-width: $cordel-breakpoint-mobile) {
      margin-top: var(--cordel-spacing-nano);
      padding: var(--cordel-spacing-xl) 0 var(--cordel-spacing-blaster) 0;
    }
  }
</style>
